import { PAYServiceCode } from '@/shared/types/serviceCodes';

export const SERVICE_CODE = PAYServiceCode.PAYMENT_WITHOUT_APPLICATION;
export const STEP_NUMBER_TO_PAY = 3;
export const STEP_NUMBER_TO_RESULT = 4;
export const AWARD_WEAPON_PERMIT_CODE = '1070016';
export const WEAPON_CONTROL_DEPT_ID = 'd9b7a912-d881-491b-8327-84832350138b';
export const PAY_01_OPER_ID = '/pay01/oper_id';
export const PAY_01_REDIRECT_URI = '/pay01/redirect_uri';
